import React from 'react';

/**
 * Why You'll Love This Recipe Template
 * Reusable section that appears after introduction in recipe articles
 * Highlights key benefits and appeal of the recipe
 */
export const WhyYoullLoveTemplate = ({
  benefits = []
}) => {
  // Default benefits if none provided
  const defaultBenefits = [
    'Quick and easy to prepare',
    'Packed with flavor and nutrition',
    'Perfect for any occasion',
    'Customizable to your taste preferences',
    'Budget-friendly ingredients'
  ];

  const displayBenefits = benefits?.length > 0 ? benefits : defaultBenefits;

  return `<!-- wp:html -->
<style>
  .why-youll-love-section {
    max-width: 760px;
    margin: 2rem auto;
    padding: 1.5rem;
    background: linear-gradient(135deg, #fff8e8 0%, #ffe8f0 100%);
    border-radius: 16px;
    border-left: 4px solid #ff6b9d;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }
  .why-youll-love-section h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .why-youll-love-section h2::before {
    content: "💖";
    font-size: 1.8rem;
  }
  .why-youll-love-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .why-youll-love-list li {
    margin-bottom: 0.75rem;
    padding-left: 1.75rem;
    position: relative;
    line-height: 1.6;
    color: #444;
  }
  .why-youll-love-list li::before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #ff6b9d;
    font-weight: bold;
    font-size: 1.2rem;
  }
  @media (max-width: 600px) {
    .why-youll-love-section {
      padding: 1.25rem;
    }
    .why-youll-love-section h2 {
      font-size: 1.3rem;
    }
  }
</style>
<div class="why-youll-love-section">
  <h2>Why You'll Love This Recipe</h2>
  <ul class="why-youll-love-list">
    ${displayBenefits?.map(benefit => `<li>${benefit}</li>`)?.join('\n    ')}
  </ul>
</div>
<!-- /wp:html -->`;
};

export default WhyYoullLoveTemplate;